module.exports = __webpack_public_path__ + "static/logoSchulichYork-67dec667e2123901d1d3c6a7dce3cdcd.jpg";